import { useState, useEffect } from "react";
import withLoader from "../../../components/layouts/WithLoader"
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import BankService from "../../../services/PosService/BankService";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import UtilsFormule from "../../../utils/UtilsFormule";
import { TextField } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import PrintableK from "../PrintableK";
import nombreEnTexte from "../../../utils/NombreEnTexte";
import BanqueService from "../../../services/Banque";
const styles = {
    container: (base) => ({
        ...base,
        flex: 1,
    }),
};
const ChargerWalletCheque = ({ startLoading, stopLoading }) => {
    const animatedComponents = makeAnimated();

    const navigate = useNavigate();

    const [datePayementCheque, setDatePayementCheque] = useState("");
    const [codePayementCheque, setCodePayementCheque] = useState("");
    const [emetteurCheque, setEmetteurCheque] = useState("");

    const [searchPay, setSearchPay] = useState("");
    const [listSearchPay, setListSearchPay] = useState([]);
    const [isSearchPay, setIsSearchPay] = useState(false);
    const [disableInputs, setDisableInputs] = useState(false);
    const [fileName, setFileName] = useState("");
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successAlertText, setSuccessAlertText] = useState();
    const [infoAlertText, setInfoAlertText] = useState();
    const [file, setFile] = useState([]);
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [amount, setAmount] = useState();
    const [selectedOption, setSelectedOption] = useState(null);
    const [data, setData] = useState({
        date1: '',
        city: '',
        date2: new Date().toISOString().split('T')[0], // Current date in 'YYYY-MM-DD' format
        reference: '',
        amount: '',
        message1: "",
        message2: "",
        amountWords: '',
        name: '',
        testMessage: '',
        bank: '',
        description:''
    });
    const handleCityChange = (event) => {
        setData({
            ...data,
            city: event.target.value, // Update the city value in the state
        });
    };


     const handleDescriptionChange = (event) => {
        setData({
            ...data,
            description: event.target.value, // Update the city value in the state
        });
    };
    const [payementSelectPlaceHolder, setPayemenSelectPlaceHolder] =
        useState("Choisir...");
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    useEffect(() => {
        const retrievedRow = JSON.parse(sessionStorage.getItem("wallet"));
        console.log(retrievedRow)
        if (retrievedRow) {
            const { firstName } = retrievedRow.userCreation || {};
            const { title } = retrievedRow.tier || {};

            setData((prevData) => ({
                ...prevData,
                message1: title,
                message2: title,
                name: firstName,
            }));
        }

        // const fetchBankAccounts = async () => {
        //     try {
        //         const response = await BanqueService.getAllBankAccounts(1);
        //         if (response.data?.Banque) {
        //             // Handle the case where "Banque" exists but is empty or contains data
        //         } else if (response.data?.success?.length > 0) {
        //             const bankDetails = response.data.success[0];
        //             setData((prevData) => ({
        //                 ...prevData,
        //                 reference: bankDetails?.rib,
        //                 bank: bankDetails?.name,
        //             }));
        //         }
        //     } catch (error) {
        //         console.error("Error fetching bank accounts:", error);
        //     }
        // };

        // fetchBankAccounts();
    }, []);
    const changeDatePayementCheque = (event) => {
        setDatePayementCheque(event.target.value.concat(":59"));
        setData({
            ...data,
            date1: event.target.value.split('T')[0], // Update the city value in the state
        });
    };
    const changeAmount = (event) => {
        setAmount(event.target.value);
        setData({
            ...data,
            amount: event.target.value, // Update the city value in the state
            amountWords: nombreEnTexte(event.target.value)
        });
    };

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const changeCodePayementCheque = (event) => {
        setCodePayementCheque(event.target.value);

    };
    const changeSearchPay = (event) => {
        setSearchPay(event.target.value);
    };

    const onUploadFileHandler = (e) => {
        if (e.target.files[0].size > 2097152) {
            setOpenInfoAlert(true);
            setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
        } else {
            setFileName(e.target.files[0].name);

            setFile(e.target.files[0]);
        }
    };

    const payerBill = (e) => {
        const url = window.location.pathname.split("/")[1];
        if (url === "chargerWallet") {
            if (codePayementCheque === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le code de chèque/traite est vide ");
            } else if (datePayementCheque === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : la date est vide ");
            } else if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Le montant est vide ");
            } else {
                let walletModel = {
                    idUser: getCurrentUserId(),
                    idBa: parseInt(localStorage.getItem("banqueAccount")),
                    idWallet: parseInt(sessionStorage.getItem("idWallet")),
                    typePayement: 2,
                    echanceDate: datePayementCheque,
                    ammountPayed: amount,
                    urlFile: "any",
                    codeCheque: codePayementCheque,
                };
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);
                    startLoading();
                    UploadAndDownloadService.uploadFile(
                        "/sales/uploadFileSelling/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                walletModel.urlFile = response.data.success;
                                TierAccountService.addWalletPayement(walletModel)
                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            //   toast.error("Error : il ya un probléme");
                                        } else {
                                            setOpenSuccessAlert(true);
                                            setSuccessAlertText("Enregistrement avec succées");
                                            setTimeout(() => {
                                                navigate(`/walletClient`);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        setOpenErrorAlert(true);
                                        setErrorAlertText("Erreur :  " + error);
                                    })


                            } else {
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                } else {
                    startLoading();
                    TierAccountService.addWalletPayement(walletModel)
                        .then((response) => {
                            console.log(response);
                            if (response.data["error"]) {
                            } else {
                                setOpenSuccessAlert(true);
                                setSuccessAlertText("Enregistrement avec succées");
                                setTimeout(() => {
                                    navigate(`/walletClient`);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                }
            }
        } else if (url === "chargerWalletFournisseur") {
            if (codePayementCheque === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : le code de chèque/traite est vide ");
            } else if (datePayementCheque === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : la date est vide ");
            } else if (amount === "") {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Le montant est vide ");
            } else {
                let walletModel = {
                    idUser: getCurrentUserId(),
                    idBa: parseInt(localStorage.getItem("banqueAccount")),
                    idWallet: parseInt(sessionStorage.getItem("idWallet")),
                    typePayement: 2,
                    emetteur: emetteurCheque,
                    echanceDate: datePayementCheque,
                    ammountPayed: amount,
                    urlFile: "any",
                    codeCheque: codePayementCheque,
                };
                if (file.length !== 0) {
                    const uploadData = new FormData();
                    uploadData.append("picture", file);
                    startLoading();
                    UploadAndDownloadService.uploadFile(
                        "/retail/uploadFile/uploadFile/Payement",
                        uploadData
                    )
                        .then((response) => {
                            if (response.data["success"]) {
                                walletModel.urlFile = response.data.success;
                                TierAccountService.addWalletPayementFournisseur(walletModel)
                                    .then((response) => {
                                        console.log(response);
                                        if (response.data["error"]) {
                                            //   toast.error("Error : il ya un probléme");
                                        } else {
                                            setOpenSuccessAlert(true);
                                            setSuccessAlertText("Enregistrement avec succées");
                                            setTimeout(() => {
                                                navigate(`/walletFournisseur`);
                                            }, 2000);
                                        }
                                    })
                                    .catch((error) => {
                                        setOpenErrorAlert(true);
                                        setErrorAlertText("Erreur :  " + error);
                                    })


                            } else {
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        })
                        .finally(() => {
                            stopLoading();
                        });
                } else {
                    startLoading();

                    TierAccountService.addWalletPayementFournisseur(walletModel)
                        .then((response) => {
                            console.log(response);
                            if (response.data["error"]) {
                                //   toast.error("Error : il ya un probléme");
                            } else {
                                setOpenSuccessAlert(true);
                                setSuccessAlertText("Enregistrement avec succées");
                                setTimeout(() => {
                                    navigate(`/walletFournisseur`);
                                }, 2000);
                            }
                        })
                        .catch((error) => {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :  " + error);
                        }).finally(() => {
                            stopLoading();
                        });
                }
            }
        }
    };
    const searchPayement = () => {
        startLoading();
        BankService.searchPayementByRef(getCurrentUserId(), 2, searchPay).then((response) => {

            let backendData = [{}];

            response.data.success.map((element) => {
                let elem = {
                    value: element["codeCheque"], label: element["codeCheque"] + "-" + element["emetteur"], customElements: {
                        amount: element["amountPayed"],
                        dateEcheance: UtilsFormule.formatDateInput(element["echeanceDate"]),
                        emetteur: element["emetteur"]
                    }
                };
                backendData.push(elem);
            })
            setListSearchPay(backendData)
            setIsSearchPay(true)
            console.log(response)
        }).catch((e) => {
            console.log(e)

        }).finally(() => {
            stopLoading();
        })

    }
    const handleSuccessClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSuccessAlert(false);
    };
    const onChangeSelectedCheque = (selectedOptionn) => {
        setSelectedOption();
        setPayemenSelectPlaceHolder(selectedOptionn.label);
        setAmount(selectedOptionn.customElements.amount);
        setCodePayementCheque(selectedOptionn.value);
        setDatePayementCheque(selectedOptionn.customElements.dateEcheance);
        setEmetteurCheque(selectedOptionn.customElements.emetteur);
        setDisableInputs(true);

    };
    return (
        <>
            <br />
            <div className="row">
                <div className="col-12">
                    <label>Charger le wallet par chèque / traite: </label>
                </div>
            </div>

            <div className="input-group">
                <div
                    className="input-group-prepend"
                    style={{ width: "95%" }}
                >
                    <input
                        value={searchPay}
                        onChange={changeSearchPay}
                        class="form-control"
                        placeholder="chercher payement"
                        type="text"
                    />
                </div>
                <div className=" input-group-append">
                    <button
                        onClick={searchPayement}
                        type="button"
                        class="btn btn-dark"
                    >
                        <i class="fas  fa-solid fa-arrow-down"></i>
                    </button>
                </div>
            </div>
            <br />
            {isSearchPay && <Select
                styles={styles}
                closeMenuOnSelect={true}
                components={animatedComponents}
                defaultValue={selectedOption}
                onChange={onChangeSelectedCheque}
                options={listSearchPay}
                placeholder={payementSelectPlaceHolder}
            />}
            <div class="row">
                <div class="col-md-4">
                    <label>Montant : </label>
                    <input
                        type="number"
                        min="0"
                        step="0.1"
                        class="form-control"
                        placeholder="Montant "
                        name="amount"
                        value={amount}
                        onChange={changeAmount}
                        disabled={disableInputs}
                    />
                </div>
                <div class="col-md-4">
                    <label>Code Chèque: </label>
                    <input
                        value={codePayementCheque}
                        onChange={changeCodePayementCheque}
                        class="form-control"
                        placeholder="Code du chéque"
                        type="number"
                        disabled={disableInputs}

                    />
                </div>

                <div class="col-md-4">
                    <label>Date de l'échéance </label>
                    <br />
                    <TextField
                        style={{ width: "100%" }}
                        className="col-sm-12"
                        variant="outlined"
                        value={datePayementCheque}
                        onChange={changeDatePayementCheque}
                        id="datetime-local"
                        type="datetime-local"
                        defaultValue="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        size="small"
                        disabled={disableInputs}

                    />
                </div>

                <div class="col-md-12">
                    <div className="row">
                        <div className="col-sm-12">
                            <div class="form-group">
                                <label for="exampleInputFile">Ajouter chèque </label>
                                <div class="input-group">
                                    <div class="custom-file">
                                        <input
                                            accept="application/pdf, .jpg, .jpeg, .png"
                                            type="file"
                                            className="custom-file-input"
                                            id="exampleInputFile"
                                            onChange={onUploadFileHandler}
                                        />
                                        <label class="custom-file-label" for="exampleInputFile">
                                            {fileName}{" "}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <label>Compte bancaire </label>
                    <ListBanquesToPayement type={1} />
                </div>
                <div className="col-6">
                    <label>Lieux de création</label>
                    <br />
                    <TextField
                        style={{ width: '100%' }}
                        className="col-sm-12"
                        variant="outlined"
                        value={data.city} // Bind the value to data.city
                        onChange={handleCityChange} // Call the handleCityChange function when the value changes
                        type="text"
                        size="small"
                    />
                </div>
                 <div className="col-6">
                    <label>Description</label>
                    <br />
                    <TextField
                        style={{ width: '100%' }}
                        className="col-sm-12"
                        variant="outlined"
                        value={data.description} // Bind the value to data.city
                        onChange={handleDescriptionChange} // Call the handleCityChange function when the value changes
                        type="text"
                        size="small"
                    />
                </div>
                <br />
                <div class="col-12">
                    <button
                        type="submit"
                        onClick={payerBill}
                        className="btn my-1 btn-dark float-right"
                    >
                        Payer
                    </button>
                    <PrintableK data={data} />
                </div>
            </div>
            <Snackbar
                open={openSuccessAlert}
                autoHideDuration={2000}
                onClose={handleSuccessClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleSuccessClose} severity="success">
                    {successAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
            <Snackbar
                open={openInfoAlert}
                autoHideDuration={4000}
                onClose={handleInfoClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert onClose={handleInfoClose} severity="info">
                    {infoAlertText}
                </Alert>
            </Snackbar>
        </>
    );


}
export default withLoader(ChargerWalletCheque)

